export default "__VITE_ASSET__BBx9x_AG__"